var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWaiting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 4V15H18.6665V6H2.6665V15H0.666504V4L10.6665 0L20.6665 4ZM17.6665 7H3.6665V9H17.6665V7ZM17.6665 13H3.6665V15H17.6665V13ZM17.6665 10H3.6665V12H17.6665V10Z",
    fill: "#0DAB01"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWaiting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_waiting.de894979fb03b31447a7a54dfe2762f1.svg";